<template>
  <div>
    <vue-headful title="Credimóvil | Comparador de autos "/>
    <menu-component></menu-component>
    <!-- Banner Area -->
    <section class="banner_area banner_area_car">
      <div class="container">
    		<h6></h6>
    		<h2>Comparador de autos</h2>
        <ol class="breadcrumb">
              <li></li>
          </ol>
    	</div>
    </section>
    <!-- Banner Area -->
    <section class="potential_area poa_2 content-card">
      <div class="container">
          <div class="tittle">
              <h2>Encuentra el auto de tus sueños</h2>
          </div>
          <div class="row buy-car-box" >
            <div class="col-lg-12 col-md-12">
              <div class="back-form-car">
                  <form class="from_main">
                      <div class="row">
                        <div class="row col-lg-10">
                          <div class="col-lg-4 select_from">
                              <h6>Modelo</h6>
                              <select class="post_select" id="model" :class="{ 'error': $v.form.selectedModel.$invalid }">
                                <option value="">Modelo*</option>
                                <option v-for="model in models" v-bind:key="model">{{model}}</option>
                              </select>
                          </div>
                          <div class="col-lg-4 select_from">
                              <h6>Marca</h6>
                              <select class="post_select" id="brand" :disabled="form.selectedModel == ''" :class="{ 'error': $v.form.selectedBrand.$invalid }">
                                <option value="">Marca*</option>
                                <option v-for="brand in brands">{{brand}}</option>
                              </select>
                          </div>
                          <div class="col-lg-4 select_from">
                              <!-- <h6>Palaras clave</h6>
                              <input type="text" class="post_input" placeholder="Escribe algo"
                                id="key_word" name="key_word" v-model="form.keyWords" 
                                required> -->
                              <h6>Version</h6>
                              <select class="post_select" id="version" :disabled="form.selectedBrand == ''" :class="{ 'error': $v.form.selectedVersion.$invalid }">
                                <option value="">Version*</option>
                                <option v-for="version in versions">{{version}}</option>
                              </select>
                          </div>
                        </div>
                        <div class="col-lg-2">
                          <button type="button" class="align-bottom theme_btn btn btn-block" style="width: 100%; margin-top: 13px;" v-on:click="search()">
                            Buscar
                          </button>
                        </div>
                      </div>
                  </form>
              </div>
            </div>
          </div>
      </div>
    </section>

    <!-- search Area -->
    <section class=" content-card">
    	<div class="container">
        <div class="features_b">
          <div class="row">
            <div class="col-auto mr-auto"><h3>Recientes</h3></div>
            <div class="col-auto">
              <a class="button letters-colored btn btn-link" href="/car-filter">Ver más</a>
              <!-- <router-link v-bind:to="'view-car/' + 1">Hola</router-link> -->
              <!-- <button type="button" class="letters-colored btn btn-link">ver más</button> -->
            </div>
          </div>
        </div>
        <br>
    		<div class="row">
          <div class="col-lg-3 col-md-6" v-for="item in data" v-bind:key="item.id">
            <a class="text-dark" v-on:click="redirect(item)" style="cursor: pointer;">
              <div class="card" style="width: 18rem; objet-fit:contain;">
                <img class="card-img-top" :src="filterImage(item.vehicle.images)" alt="Card image cap" style="object-fit: cover; height: 180px;">
                <div class="card-body">
                  <h5>{{ item.vehicle.brand }} {{ item.vehicle.model }}</h5>
                  <div class="container">
                    <div class=" clearfix"> 
                      <span class="border border-secondary">{{ item.vehicle.year }}</span>
                      {{ item.vehicle.mileage }} kms
                    </div>
                  </div>
                  <div class="container">
                    <div class="row">
                      <div class="col-lg-7">
                        <p class="card-text letters-colored">
                          <strong>$ {{ formatPrice(item.vehicle.price) }}</strong>
                        </p>
                      </div>
                      <div class="col-lg-2">
                        <img height="30px" src="images/logo@2x.png" alt="">
                      </div>
                      <div class="col-lg-3"></div>
                    </div>
                  </div>
                  <!-- <p class="card-text price-colored">
                    <strong>$ {{ item * 10000 }}</strong>
                    <img height="30px" src="images/logo@2x.png" alt="">
                  </p> -->
                </div>
              </div>
            </a>
          </div>
        </div>
    	</div>
    </section>
    <!-- search Area -->
  </div>
</template>

<script>
  import { required, minLength, between, minValue, maxValue } from 'vuelidate/lib/validators';

  export default {
    name: 'BuyCar',
    data() {
      return {
        models: [],
        brands: [],
        versions: [],
        form: {
          selectedModel: '',
          selectedBrand: '',
          selectedVersion: '',
          keyWords: '',
        },
        data: [],
      }
    },
    validations() {
      return {
        form: {
          selectedModel: { required },
          selectedBrand: { required },
          selectedVersion: { required }
        },
      }
    },
    methods: {
      status(validation) {
    	  return validation.$invalid;
      },
      refreshSelects() {
        $('#model').niceSelect('update');
        $('#brand').niceSelect('update');
        $('#version').niceSelect('update');
      },
      getData() {
        this.$VehicleService.getVehiclesRecents().then((result) => {
          this.data = result.data;
        }, (err) => {
          alert(err.message);
        });
      }, 
      getModels() {
        this.$InsuranceService.getModels().then((result) => {
          this.models = result.data.model.slice(0,14);

          setTimeout(() => {
            this.refreshSelects();

            $('#model').on('change', () => {
              this.form.selectedModel = $('#model').val();
              $('#brand').val('');
              this.form.selectedBrand = '';
              $('#version').val('');
              this.form.selectedVersion = '';

              this.getBrands();

              setTimeout(() => {
                this.refreshSelects();
              }, 100);
            });
          }, 100);
        }, (err) => alert(err.msg));
      },
      getBrands() {
        if (this.form.selectedModel != '') {
          const data = {
            model: this.form.selectedModel
          };

          this.$InsuranceService.getBrands(data).then((result) => {
            this.brands = result.data.brand;

            setTimeout(() => {
              this.refreshSelects();

              $('#brand').on('change', () => {
                this.form.selectedBrand = $('#brand').val();
                console.log(this.form.selectedBrand);
                $('#version').val('');
                this.form.selectedVersion = '';

                this.getVersions();

                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          }, (err) => alert(err.msg));
        }
      },
      getVersions() {
        if (this.form.selectedBrand != '') {
          const data = {
            model: this.form.selectedModel,
            brand: this.form.selectedBrand
          };

          this.$InsuranceService.getVersions(data).then((result) => {
            this.versions = result.data.version;
            console.log(this.versions)

            setTimeout(() => {
              this.refreshSelects();

              $('#version').on('change', () => {
                this.form.selectedVersion = $('#version').val();

                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          }, (err) => alert(err));
        }
      },
      formatPrice(value) {
          let num = (value/1).toFixed(2);
          return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      filterImage(item) {
        if (item.length == 0 ) {
          return 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22286%22%20height%3D%22180%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20286%20180%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_172c887333d%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A14pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_172c887333d%22%3E%3Crect%20width%3D%22286%22%20height%3D%22180%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%2298.91666793823242%22%20y%3D%2295.7%22%3EImage%20cap%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E';
        } else {
          let flag = false;
          let url = '';

          for( let i = 0 ; i < item.length ; i++ ) {
            if (item[i].url.includes('.jpg') || item[i].url.includes('.jpeg') || item[i].url.includes('.png') ) {
              flag = true;
              url = item[i].url;
            }
          }

          if (flag) {
            return url;
          }
          return 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22286%22%20height%3D%22180%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20286%20180%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_172c887333d%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A14pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_172c887333d%22%3E%3Crect%20width%3D%22286%22%20height%3D%22180%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%2298.91666793823242%22%20y%3D%2295.7%22%3EImage%20cap%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E';
        }
      },
      search() {
        localStorage.setItem('model', this.form.selectedModel);
        localStorage.setItem('brand', this.form.selectedBrand);
        localStorage.setItem('version', this.form.selectedVersion);

        // this.$router.push({path: `/car-filter`});
        window.location = '/car-filter';
      },
      redirect(item) {
        localStorage.setItem('vehicleId', item.vehicle.id);
        window.location = '/view-car';
        // this.$router.push({path: `/view-car`});
      }
    },
    created() {
      this.getModels();
      this.getData();
      localStorage.removeItem('vehicleId');
      localStorage.removeItem('model');
      localStorage.removeItem('brand');
      localStorage.removeItem('version');
    }
  }
</script>

<style lang="scss">

  .error {
    border-color: red !important;
  }
  .post_input{
    position: relative;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: none;
    outline: none;
    font: 400 16px/40px "Source Sans Pro", sans-serif;
    padding: 0 25px;
    height: auto;
    border-radius: 5px;
    color: rgba(0, 0, 0, 0.6);
    min-width: 100%;
  }

  .post_select, .post_select.disabled {
    position: relative;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: none;
    outline: none;
    font: 400 16px/40px "Source Sans Pro", sans-serif;
    padding: 0 25px;
    height: auto;
    border-radius: 5px;
    color: rgba(0, 0, 0, 0.6);
    min-width: 100%;
    // background-color: transparent;
    .list {
      height: 305% !important;
    }
  }

  .buy-car-box {
  //   /* display: block;
  //   overflow: hidden; */
    background: #181a3c;
    color: white;
    // margin: 130px ;
    padding: 20px;
  }

  .content-card {
      padding-bottom: 100px;
      background-color: whitesmoke;
  }
  .border{
    padding: 2px;
  }
  .letters-colored {
    color: #f59019;
  }
</style>



// WEBPACK FOOTER //
// src/views/BuyCar.vue